import { render, staticRenderFns } from "./LicenseDetails.vue?vue&type=template&id=e458c2e8&"
import script from "./LicenseDetails.vue?vue&type=script&lang=ts&"
export * from "./LicenseDetails.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseDetails.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports